module.exports = __webpack_public_path__ + "static/media/0008.4836e114.jpg";